import apiClient from './api'

export interface ReconciliationRecord {
  date: string
  deposits: {
    count: number
    amount: number
    reconciled: number
    variance: number
  }
  withdrawals: {
    count: number
    amount: number
    reconciled: number
    variance: number
  }
  status: 'reconciled' | 'pending' | 'variance'
  variance: number
}

export const reconciliationService = {
  // Get reconciliation for a specific date
  getReconciliation: async (date: string): Promise<ReconciliationRecord[]> => {
    try {
      const response = await apiClient.get('/reports/reconciliation', { params: { date } })
      return response.data.records || response.data || []
    } catch (error) {
      console.error('Failed to fetch reconciliation', error)
      return []
    }
  },

  // Get reconciliation summary
  getReconciliationSummary: async (startDate: string, endDate: string) => {
    try {
      const response = await apiClient.get('/reports/reconciliation/summary', {
        params: { start_date: startDate, end_date: endDate },
      })
      return response.data
    } catch (error) {
      console.error('Failed to fetch reconciliation summary', error)
      return null
    }
  },

  // Export reconciliation report
  exportReconciliation: async (date: string, format: 'csv' | 'pdf' = 'csv') => {
    try {
      const response = await apiClient.get(`/reports/reconciliation/export`, {
        params: { date, format },
        responseType: 'blob',
      })
      return response.data
    } catch (error) {
      console.error('Failed to export reconciliation', error)
      throw error
    }
  },
}


